import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { useSelector } from 'react-redux'
import { getSelectedCustomerId } from '../selectors/customers'
import prepareHeaders from '../utils/prepareHeaders'

export const customerGraphResourcesApi = createApi({
  reducerPath: 'customerGraphResources',
  baseQuery: fetchBaseQuery({
    prepareHeaders,
    baseUrl: process.env.REACT_APP_AUGMENTT_API_URL,
  }),
  endpoints: (builder) => ({
    getCustomerServicePrincipals: builder.query({
      query: ({ customerId, params }) => ({
        url: `/customer/${customerId}/service-principals`,
        params,
      }),
    }),
    getCustomerDirectoryRoleDefinitions: builder.query({
      query: ({ customerId }) => ({
        url: `/customer/${customerId}/directory-role-definitions`,
      }),
    }),
  }),
})

export const {
  useGetCustomerServicePrincipalsQuery,
  useLazyGetCustomerServicePrincipalsQuery,
  useLazyGetCustomerDirectoryRoleDefinitionsQuery,
} = customerGraphResourcesApi

export const useGetCustomerServicePrincipals = () => {
  const customerId = useSelector(getSelectedCustomerId)

  return useGetCustomerServicePrincipalsQuery({ customerId })
}
